const stats = [
  { label: 'Fundado', value: '2023' },
  { label: 'Países', value: '50+' },
  { label: 'Clientes', value: '+150' },
]

export default function WeContent() {
  return (
    <div className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-4">
            <div className="relative overflow-hidden rounded-3xl bg-gray-900 px-6 pb-9 pt-64 shadow-2xl sm:px-12 lg:max-w-lg lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
              <video
                src="/Video/Despega.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="absolute inset-0 size-full rounded-3xl object-cover"
              />
              <div className="absolute inset-0 bg-gray-900/60" />

              <figure className="relative isolate">
                <blockquote className="mt-6 text-xl/8 font-semibold text-white">
                  <p>
                    “En Despega creemos que viajar transforma vidas. Por eso hacemos que cada destino,
                    trámite y experiencia sea fácil, segura y memorable.”
                  </p>
                </blockquote>
                <figcaption className="mt-6 text-sm/6 text-gray-300">
                  <strong className="font-semibold text-white"></strong> - Despega GT
                </figcaption>
              </figure>
            </div>
          </div>
          <div>
            <div className="text-base/7 text-gray-700 lg:max-w-lg">
              <p className="text-base/7 font-semibold text-indigo-600">Sobre nosotros</p>
              <h1 className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Despega, tu puerta al mundo
              </h1>

              <div className="max-w-xl">
                <p className="mt-6">
                  En <strong>Despega</strong> somos una agencia de viajes comprometida con convertir tus sueños
                  en experiencias reales. Ofrecemos viajes nacionales e internacionales, tours personalizados,
                  asesoría en visas, trámites de pasaporte y acompañamiento en cada paso de tu aventura.
                </p>

                <p className="mt-8">
                  Trabajamos con destinos en más de 50 países, conectando culturas, experiencias y momentos
                  inolvidables. Nuestro enfoque es brindarte precios competitivos, atención personalizada
                  y la tranquilidad de viajar con expertos.
                </p>

                <p className="mt-8">
                  Ya sea tu primer viaje, unas vacaciones soñadas o un trámite importante,
                  en Despega estamos listos para ayudarte a despegar sin límites.
                </p>
              </div>
            </div>
            <dl className="mt-10 grid grid-cols-2 gap-8 border-t border-gray-900/10 pt-10">
              {stats.map((stat, statIdx) => (
                <div key={statIdx}>
                  <dt className="text-sm/6 font-semibold text-gray-600">{stat.label}</dt>
                  <dd className="mt-2 text-3xl/10 font-bold tracking-tight text-gray-900">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>

            <div className="mt-10 flex">
              <a
                href="https://wa.me/50239990332"
                target="_blank"
                rel="noopener noreferrer"
                className="text-base/7 font-semibold text-indigo-600 hover:text-indigo-500"
              >
                Cotiza tu próximo viaje con nosotros <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}